import { render, staticRenderFns } from "./SpecialPackaging.vue?vue&type=template&id=2f3a2f04"
import script from "./SpecialPackaging.vue?vue&type=script&lang=js"
export * from "./SpecialPackaging.vue?vue&type=script&lang=js"
import style0 from "./SpecialPackaging.vue?vue&type=style&index=0&id=2f3a2f04&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports